import { render, staticRenderFns } from "./ClaimParticipantBase.vue?vue&type=template&id=2ba0bfcc&scoped=true"
import script from "./ClaimParticipantBase.vue?vue&type=script&lang=js"
export * from "./ClaimParticipantBase.vue?vue&type=script&lang=js"
import style0 from "./ClaimParticipantBase.vue?vue&type=style&index=0&id=2ba0bfcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba0bfcc",
  null
  
)

export default component.exports